import { render, staticRenderFns } from "./Buyer.vue?vue&type=template&id=028aa57e&scoped=true&"
import script from "./Buyer.vue?vue&type=script&lang=ts&"
export * from "./Buyer.vue?vue&type=script&lang=ts&"
import style0 from "./Buyer.vue?vue&type=style&index=0&lang=css&"
import style1 from "./Buyer.vue?vue&type=style&index=1&id=028aa57e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "028aa57e",
  null
  
)

export default component.exports